export default function GraphicalAccordion() {
  document.querySelectorAll(".c-graphical-accordion").forEach((accordion) => {
    const buttons = Array.from(
      accordion.querySelectorAll(".c-graphical-accordion__button"),
    );

    accordion
      .querySelectorAll(".c-graphical-accordion__item--open")
      .forEach((item) => item.classList.add("is-init"));

    requestAnimationFrame(() => {
      accordion
        .querySelectorAll(".c-graphical-accordion__item.is-init")
        .forEach((item) => item.classList.remove("is-init"));
    });

    const images = Array.from(
      accordion.querySelectorAll(".c-graphical-accordion__picture"),
    );

    buttons.forEach((button, idx) => {
      button.addEventListener("click", () => {
        toggleItem(accordion, button, idx, images);
      });

      button.addEventListener("keydown", (e) => {
        switch (e.key) {
          case "ArrowDown":
            e.preventDefault();
            (buttons[idx + 1] || buttons[0]).focus();
            break;
          case "ArrowUp":
            e.preventDefault();
            (buttons[idx - 1] || buttons[buttons.length - 1]).focus();
            break;
          case "Home":
            e.preventDefault();
            buttons[0].focus();
            break;
          case "End":
            e.preventDefault();
            buttons[buttons.length - 1].focus();
            break;
        }
      });
    });
  });

  function toggleItem(accordion, button, idx, images) {
    const item = button.closest(".c-graphical-accordion__item");
    if (!item || item.classList.contains("c-graphical-accordion__item--open"))
      return;

    const openItem = accordion.querySelector(
      ".c-graphical-accordion__item--open",
    );

    if (images.length > 1) {
      images.forEach((img, i) => {
        const isActive = i === idx;
        img.classList.toggle("c-graphical-accordion__picture--active", isActive);
        img.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    }

    const openNext = () => {
      const panel = item.querySelector(".c-graphical-accordion__panel");
      item.classList.add("c-graphical-accordion__item--open");
      button.setAttribute("aria-expanded", "true");
      if (panel) panel.setAttribute("aria-hidden", "false");
    };

    if (openItem) {
      const openTrigger = openItem.querySelector(
        ".c-graphical-accordion__button",
      );
      const openPanel = openItem.querySelector(".c-graphical-accordion__panel");

      openItem.classList.remove("c-graphical-accordion__item--open");
      if (openTrigger) openTrigger.setAttribute("aria-expanded", "false");
      if (openPanel) openPanel.setAttribute("aria-hidden", "true");

      if (openPanel) {
        openPanel.addEventListener(
          "transitionend",
          (e) => {
            if (e.propertyName === "opacity") openNext();
          },
          { once: true },
        );
      } else {
        openNext();
      }
    } else {
      openNext();
    }
  }
}
